import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FullCalendarModule } from '@fullcalendar/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent} from './public/main/main.component'
import { EventPageComponent } from './public/event-page/event-page.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction'; // a plugin

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin
]);


import {  NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule  } from '@angular-material-components/datetime-picker';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

//Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


//Communicating with backend services using HTTP
import { HttpClientModule } from '@angular/common/http';

//Upload image files with FormData
import { FileUploadModule } from 'ng2-file-upload';

//Angular Material Components
import { CarouselModule } from 'ngx-bootstrap/carousel';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatCheckboxModule} from '@angular/material/checkbox'; 
import {MatButtonModule} from '@angular/material/button'; 
import {MatBadgeModule} from '@angular/material/badge'
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import { RouterModule } from '@angular/router';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { MatNativeDateModule } from '@angular/material/core';
import { ToastrModule } from 'ngx-toastr';
import { MybookingsComponent } from './private/mybookings/mybookings.component';
import { VerifyEmailComponent } from './public/verify-email/verify-email.component';
import { AddeventComponent } from './private/addevent/addevent.component';
import { AccountsettingsComponent } from './private/accountsettings/accountsettings.component';
import { WavesModule, TableModule, InputsModule } from 'angular-bootstrap-md';

import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { MatSelectCountryModule } from '@angular-material-extensions/select-country';
import { FavoritesComponent } from './private/favorites/favorites.component';
import { ResetpasswordComponent } from './private/resetpassword/resetpassword.component';
import { DatePipe } from '@angular/common';
import { MycreatedeventsComponent } from './private/mycreatedevents/mycreatedevents.component';
import { SponsoreventComponent } from './private/sponsorevent/sponsorevent.component';
import { DashboardComponent } from './private/admin/dashboard/dashboard.component';
import { ChartsModule } from 'ng2-charts';
import { ResetpassmodalComponent } from './private/resetpassmodal/resetpassmodal.component';
import { PendingeventsComponent } from './private/admin/pendingevents/pendingevents.component';
import { AlleventsComponent } from './private/admin/allevents/allevents.component';
import { SponsoredeventsComponent } from './private/admin/sponsoredevents/sponsoredevents.component';
import { LoginappComponent } from './loginapp/loginapp.component';
import { DetailedeventComponent } from './private/admin/detailedevent/detailedevent.component';
import { AdminmanagementComponent } from './private/admin/adminmanagement/adminmanagement.component';
import { UsermanagementComponent } from './private/admin/usermanagement/usermanagement.component';
import { CategoriesComponent } from './private/admin/categories/categories.component';
import { AdsComponent } from './private/admin/ads/ads.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AgmCoreModule } from '@agm/core';
import { EditeventComponent } from './private/editevent/editevent.component';
import { AboutComponent } from './public/about/about.component';
import { ManagepartnersComponent } from './private/admin/managepartners/managepartners.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ParatnerscategoryComponent } from './private/admin/paratnerscategory/paratnerscategory.component';
import { PartnersComponent } from './public/about/partners/partners.component';
import { BulkemailComponent } from './private/admin/bulkemail/bulkemail.component';
import { QuillModule } from 'ngx-quill'
import { BarRatingModule } from "ngx-bar-rating";
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { DetailedadComponent } from './private/admin/detailedad/detailedad.component';
import { GetInTouchComponent } from './public/about/get-in-touch/get-in-touch.component';
import { RibbonComponent } from './private/admin/ribbon/ribbon.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CreateadComponent } from './private/createad/createad.component';
import { PendingadsComponent } from './private/admin/pendingads/pendingads.component';
import { ManagepackagesComponent } from './private/admin/managepackages/managepackages.component';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { ApidocsComponent } from './public/about/apidocs/apidocs.component';
import { RecyclingComponent } from './public/recycling/recycling.component';
import { UserAdsComponent } from './private/admin/ads/user-ads/user-ads.component';


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    EventPageComponent,
    MybookingsComponent,
    VerifyEmailComponent,
    AddeventComponent,
    AccountsettingsComponent,
    FavoritesComponent,
    ResetpasswordComponent,
    MycreatedeventsComponent,
    SponsoreventComponent,
    DashboardComponent,
    ResetpassmodalComponent,
    PendingeventsComponent,
    AlleventsComponent,
    SponsoredeventsComponent,
    LoginappComponent,
    DetailedeventComponent,
    AdminmanagementComponent,
    UsermanagementComponent,
    CategoriesComponent,
    AdsComponent,
    PartnersComponent,
    EditeventComponent,
    AboutComponent,
    ManagepartnersComponent,
    ParatnerscategoryComponent,
    BulkemailComponent,
    EditeventComponent,
    DetailedadComponent,
    GetInTouchComponent,
    RibbonComponent,
    CreateadComponent,
    PendingadsComponent,
    ManagepackagesComponent,
    ApidocsComponent,
    RecyclingComponent,
    UserAdsComponent
    
  ],
  imports: [
    //Communicating with backend services using HTTP
    HttpClientModule,
    AutocompleteLibModule,
    MatSelectCountryModule,
    NgxSpinnerModule,
    NgxSkeletonLoaderModule,
    // IvyCarouselModule,
    ChartsModule,
    MatBadgeModule,
    GooglePlaceModule,
    FileUploadModule,
    BarRatingModule,
    ColorPickerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCCP5CF3Rvo2L_z6jppuDjIhuIaxyvel-4',
      libraries: ["places"]
    }),
    DragDropModule,
    NgbModule,
    QuillModule.forRoot(),
    AppRoutingModule,
    FullCalendarModule,
    ReactiveFormsModule,
    ShareButtonsModule,
    ShareIconsModule,
    FormsModule,
    MatDatepickerModule,    
    WavesModule, 
    TableModule, 
    InputsModule,
    // CarouselModule.forRoot(),
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    MatNativeDateModule ,
    FontAwesomeModule,
    RouterModule.forRoot([]),
    NgxUsefulSwiperModule,
    BrowserModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMaterialTimepickerModule,
    NgxMatNativeDateModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  
    MatCheckboxModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NgxChartsModule,
    NgbModule,
    CarouselModule.forRoot()
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent],
  entryComponents: [ResetpassmodalComponent]
})
export class AppModule { }
